// extracted by mini-css-extract-plugin
module.exports = {"submenuContainer":"OurWorkSubmenu_submenuContainer__3spUO","submenu":"OurWorkSubmenu_submenu__2uEDm","tm":"OurWorkSubmenu_tm__2pnVw","listItem":"OurWorkSubmenu_listItem__hVwGj"};